import stations from '../services/hydrologicalStations'
import { primaryStations, soundStations, hideHydrologicalStations } from '../services/hideStations';
const filterStations = (listToTransform) => {
    // Filtering and adding hydrological stations
    const filteredList = stations.hydrologicalStations.filter(item => {
        return !listToTransform.some(originalItem => originalItem.name === item.name);
    });
    const stationsList = [...listToTransform, ...filteredList]

    // Remove soundStations and primaryStations
    const hideStations = stationsList.filter(item => {
        return ![...primaryStations, ...soundStations, ...hideHydrologicalStations].some(station => station.name === item.name);
    });

    const sortedStations = hideStations.sort((a, b) => a.name.localeCompare(b.name));

    return sortedStations;
}
export default filterStations;